define(["exports", "styled-components"], function (_exports, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Small = _exports.P = _exports.H3 = _exports.H2 = _exports.H1 = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var H1 = _styledComponents.default.h1.withConfig({
    displayName: "Typography__H1",
    componentId: "sc-the1uj-0"
  })(["font-size:2.4em;font-weight:", ";line-height:32px;"], function (_ref) {
    var theme = _ref.theme;
    return theme.font.semibold;
  });

  _exports.H1 = H1;

  var H2 = _styledComponents.default.h2.withConfig({
    displayName: "Typography__H2",
    componentId: "sc-the1uj-1"
  })(["font-size:2em;font-weight:", ";line-height:24px;"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.semibold;
  });

  _exports.H2 = H2;

  var H3 = _styledComponents.default.h3.withConfig({
    displayName: "Typography__H3",
    componentId: "sc-the1uj-2"
  })(["font-size:1.6em;font-weight:", ";line-height:24px;"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.semibold;
  });

  _exports.H3 = H3;

  var P = _styledComponents.default.p.withConfig({
    displayName: "Typography__P",
    componentId: "sc-the1uj-3"
  })(["color:", ";font-size:1.6em;font-weight:", ";line-height:24px;"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.dark;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.regular;
  });

  _exports.P = P;
  var Small = (0, _styledComponents.default)(P).withConfig({
    displayName: "Typography__Small",
    componentId: "sc-the1uj-4"
  })(["font-size:1.4em;line-height:20px;"]);
  _exports.Small = Small;
});